import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import SingleContentModal from 'shared/components/SingleContentModal.jsx';

import * as FastJoinType from 'constants/FastJoinType';

const messages = defineMessages({
    title: {
        id: 'join.fast.phone_confirm.title',
        defaultMessage: 'Подтверждение номера телефона'
    },
    confirmButton: {
        id: 'join.fast.phone_confirm.confirm_button',
        defaultMessage: 'Подтвердить'
    },
    confirmationCode: {
        id: 'join.fast.phone_confirm.confirmation_code',
        defaultMessage: 'Код подтверждения'
    },
    smsReceivedText: {
        id: 'join.fast.phone_confirm.sms_received_text',
        defaultMessage: 'Вам был отправлен код по SMS. Используйте его для подтверждения номера телефона. ' +
        'Обратите внимание, что доставка SMS может занять больше минуты.'
    },
    smsSentText: {
        id: 'join.fast.phone_confirm.sms_sent_text',
        defaultMessage: 'Сообщение было отправлено. '
    },
    smsResendInfoText: {
        id: 'join.fast.phone_confirm.sms_resendinfo_text',
        defaultMessage: 'Отправить сообщение заново можно будет через {seconds} секунд. '
    },
    callResendInfoText: {
        id: 'join.fast.phone_confirm.call_resendinfo_text',
        defaultMessage: 'Повторно запросить подтверждение можно будет через {seconds} секунд.'
    },
    smsResendText: {
        id: 'join.fast.phone_confirm.sms_resend_text',
        defaultMessage: 'Отправить сообщение заново'
    },
    callResendText: {
        id: 'join.fast.phone_confirm.call_resend_text',
        defaultMessage: 'Повторно запросить подтверждение'
    },
    smsResendButtonText: {
        id: 'join.fast.phone_confirm.sms_resend_button_text',
        defaultMessage: 'Отправить'
    },
    callResendButtonText: {
        id: 'join.fast.phone_confirm.call_resend_button_text',
        defaultMessage: 'Запросить'
    },
    confirmationError: {
        id: 'join.fast.phone_confirm.errors.confirmation_fail',
        defaultMessage: 'Ошибка при подтверждении'
    },
    sms_exceeded: {
        id: 'join.fast.phone_confirm.errors.sms_exceeded',
        defaultMessage: 'Мы дважды выслали на Ваш номер сообщение для подтверждения счёта. Пожалуйста, дождитесь СМС, либо укажите e-mail и мы вышлем информацию о подтверждении счёта на него.'
    },
    invalidConfirmationCode: {
        id: 'join.fast.phone_confirm.errors.invalid_code',
        defaultMessage: 'Неправильный код'
    }
});

export default class extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        fastJoin: React.PropTypes.object.isRequired,
        inProcess: React.PropTypes.bool.isRequired,
        error: React.PropTypes.number,
        confirmPhone: React.PropTypes.func.isRequired,
        resendCode: React.PropTypes.func.isRequired,
        closeCallback: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._handleCodeConfirmClick = this._handleCodeConfirmClick.bind(this);
        this._handleResendSmsClick = this._handleResendSmsClick.bind(this);
        this._onChangeCode = this._onChangeCode.bind(this);
        this._tick = this._tick.bind(this);

        this.state = {
            showResend: false,
            seconds: 60,
            intervalId: undefined
        };
    }

    componentWillMount() {
        const intervalId = setInterval(this._tick, 1000);
        const state = this.state;

        this.setState({
            ...state,
            intervalId
        });
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (nextState.showResend && !this.state.showResend) {
            clearInterval(this.state.intervalId);
        }
        if (nextProps.fastJoin.get('RequestId') !== this.props.fastJoin.get('RequestId')) {
            clearInterval(this.state.intervalId);

            this.setState({
                showResend: false,
                seconds: 60,
                intervalId: setInterval(this._tick, 1000)
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    _tick() {
        const seconds = this.state.seconds - 1;
        const showResend = seconds <= 0;

        if (showResend) {
            clearInterval(this.state.intervalId);
        }

        this.setState({
            showResend,
            seconds
        });
    }

    _onChangeCode(e) {
        e.preventDefault();

        /*const code = e.target.value;
        let isValid = true;
        for (let offset = 0; offset < code.length; offset++) {
            const charCode = parseInt(code[offset].charCodeAt());
            if (!((charCode > 47 && charCode < 58) ||
                (charCode > 64 && charCode < 91) ||
                (charCode > 96 && charCode < 123))) {
                isValid = false;
            }
        }
        if (isValid) {
            e.target.value = e.target.value.toUpperCase();
        } else {
            e.target.value = e.target.value.substring(0, e.target.value.length - 1);
        }*/
        e.target.value = e.target.value.toUpperCase();
    }

    _handleCodeConfirmClick(e) {
        e.preventDefault();

        const {fastJoin} = this.props;

        const requestId = fastJoin.get('RequestId');
        const phone = fastJoin.get('Phone');

        const codeVal = this.refs.code.value;
        if (codeVal) {
            this.props.confirmPhone({Phone: phone, RequestId: requestId, Code: codeVal.toUpperCase()});
        }
    }

    _handleResendSmsClick(e) {
        e.preventDefault();

        const fastJoin = this.props.fastJoin;

        this.props.resendCode({
            Phone: fastJoin.get('Phone'),
            CountryId: fastJoin.get('CountryId'),
            AccountResourceId: fastJoin.get('AccountResourceId'),
            LanguageId: this.props.languageId,
            Type: FastJoinType.SMS
        });
    }

    render() {
        const {error, closeCallback, countryCode} = this.props;
        const {seconds, showResend} = this.state;
        const isUzCountry = countryCode === 'UZ'

        const codeStyle = {textTransform: 'uppercase'};

        const modalProps = {
            type: "wide",
            title: <FormattedMessage {...messages.title}/>,
            closeCallback
        };

        const formGroupClass = "form-group" + (error ? ' invalid' : '');

        let msgError = <FormattedMessage {...messages.confirmationError} />;

        if (error === -3) {
            msgError = <FormattedMessage {...messages.sms_exceeded} />;
        }

        return (
            <SingleContentModal {...modalProps}>
                <p className="plain-text__paragraph">
                    <FormattedMessage {...messages.smsReceivedText} />
                </p>

                <div className="form">
                    <div className={formGroupClass}>
                        <label>
                            <FormattedMessage {...messages.confirmationCode}/>
                        </label>
                        <input ref="code" length={6} maxLength={6} onChange={this._onChangeCode} style={codeStyle}/>
                        {error &&
                        <div className="error">
                            {msgError}
                        </div>}
                    </div>
                    {showResend && error !== -3 &&
                    <div className="form-group action">
                        <label><FormattedMessage {...(isUzCountry ? messages.callResendText : messages.smsResendText)}/></label>
                        <div className="btn btn-green" onClick={this._handleResendSmsClick}>
                            <FormattedMessage {...(isUzCountry ? messages.callResendButtonText : messages.smsResendButtonText)} />
                        </div>
                    </div>}
                </div>
                {!showResend && error !== -3 &&
                <p>
                    {!isUzCountry && (
                        <span className="success-message">
                            <FormattedMessage {...messages.smsSentText}/>
                        </span>
                    )}
                    <span className="hint-message">
                        <FormattedMessage {...(isUzCountry ? messages.callResendInfoText : messages.smsResendInfoText)} values={{seconds}}/>
                    </span>
                </p>}
                {error !== -3 && <div className="center-buttons">
                    <div className="btn btn-yellow" onClick={this._handleCodeConfirmClick}>
                        <FormattedMessage {...messages.confirmButton} />
                    </div>
                </div>}
            </SingleContentModal>);
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/fast/PhoneConfirmation.jsx